import React, { useState } from 'react';
import './PricingSection.css';

const pricingData = {
  Men: [
    ['Shirt', '95'],
    ['T-shirt', '95'],
    ['Trouser', '100'],
    ['Jeans', '100'],
    ['Cap', '50'],
    ['Tie', '60'],
    ['Sweater half sleeve', '150'],
    ['Sweater full sleeve', '250-300'],
    ['Sweater long', '300-400'],
    ['Sweat shirt', '200-300'],
    ['Coat/blazer', '300-300'],
    ['Coat pant', '300-500'],
    ['3 Piece Suit', '500-700'],
    ['Overcoat', '399-699'],
    ['Jacket half', '200-250'],
    ['Jacket full', '250-400'],
    ['Kurta Pyjama', '250-350'],
    ['Leather jacket', '399-1000'],
    ['Sherwani', '499-1000'],
  ],
  Women: [
    ['Top', '100-150'],
    ['Blouse', '70-150'],
    ['Skirt', '150-300'],
    ['Dupatta', '80-150'],
    ['Petticoat', '100-150'],
    ['Stole', '150-250'],
    ['Saree only chark', '70-100'],
    ['Saree with work', '400-800'],
    ['Shawl', '200-499'],
    ['Kurta suit', '120-150'],
    ['Kurta pajama 2pcs', '200-300'],
    ['Kurta with work', '250-300'],
    ['Kurta pajama dupatta 3pcs', '250-499'],
    ['Dress', '200-300'],
    ['Long dress', '300-500'],
    ['Coat', '250-350'],
    ['Over coat', '300-500'],
    ['Long coat', '300-500'],
    ['Jacket half', '200-250'],
    ['Jacket full sleeve', '250-400'],
    ['Lehenga 1pcs', '300-500'],
    ['Lehenga 2pcs', '500-999'],
    ['Lehenga 3pcs', '799-1499'],
  ],
  
  Household: [
    ['Pillow cover', '50-150'],
    ['Bedsheet single', '120-200'],
    ['Bedsheet double', '200-300'],
    ['Blanket single', '300'],
    ['Blanket double', '350-400'],
    ['Quilt single', '350-400'],
    ['Quilt double', '400-500'],
    ['Bed cover single', '200'],
    ['Bed cover double', '300'],
    ['Curtain without lining per panel', '180'],
    ['Curtain with lining per panel', '250'],
    ['Curtain velvet with lining per panel', '350'],
    ['Curtain with embroidery with lining per panel', '350'],
    ['Cushion cover', '70-150'],
    ['Sofa per seat fabric', '249'],
    ['Sofa per seat Swede/leather', '400'],
    ['Rugs mat', '150-200'],
    ['Rugs mat heavy', '200-300'],
    ['Carpet per square feet', '25-35'],
  ],
  
   Others:[
    ['Shoes/Sandal drycleaning', '200-499'],
    ['Bag drycleaning', '250-400'],
    ['Car cleaning', '700-1499'],
    ['Steam iron per piece (starting)', '50'],
    ['Wash & iron 15kg (3-time pickup & drop free)', '1399'],
    ['Premium laundry per kg', '149'],
    ['Premium laundry per piece', '51'],
    ['Wash & iron (per kg)', '110'],
    ['Wash & fold (per kg)', '80'],
    ['Wash & iron 30kg (5-time pickup & drop free)', '2799']
  ]
};

const PricingSection = () => {
  const [activeTab, setActiveTab] = useState('Men');

  return (
    <section className="pricing-section">
      <h2 className="pricing-title">Laundry Pricing (Rs)</h2>

      <div className="tabs">
        {['Men', 'Women', 'Household', 'Others'].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`tab-button ${activeTab === tab ? 'active' : ''}`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="pricing-grid">
        {pricingData[activeTab].map(([item, price], idx) => (
            <div key={idx} className="pricing-item">
            <div className="item-name">{item}</div>
            <div className="item-price">{price}</div>
            </div>
        ))}
        </div>

    </section>
  );
};

export default PricingSection;
